import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
var styles = {
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: flex;\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      visibility: hidden;\n      overflow: hidden;\n    "])));
  },
  textContainer: function textContainer() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      word-break: break-all;\n      white-space: nowrap;\n    "])));
  }
};
export var jsStyles = memoizeStyle(styles);